export default __webpack_public_path__ + "static/media/pvn-flyer.fc10e6d5.webp";